import { useFlag } from '@calendly/feature-check-react';
import { SearchForm } from '@calendly/form';
import { buildQuery } from '@calendly/http-tools';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { historyPush } from 'actions/core/navigation';
const containerCss = "c1n7j5sq";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
export const Search = ({
  initialValue = ''
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const meetingsPageSearch = useFlag('scheduling_meetings_page_search');
  const updateSearchParam = value => {
    const params = new URLSearchParams(history.location.search);
    if (value) {
      params.set('search_keyword', value);
    } else {
      params.delete('search_keyword');
    }
    history.replace({
      ...history.location,
      search: params.toString()
    });
  };
  const handleSubmit = searchQuery => {
    if (meetingsPageSearch) {
      updateSearchParam(searchQuery);
    } else {
      // return statement needed to keep current logic of the search page. Might remove in a follow up
      if (!searchQuery) return;
      dispatch(historyPush(`/app/meetings/search?${buildQuery({
        query: searchQuery
      })}`));
    }
  };
  const handleKeyPress = event => {
    if (event.key === 'Enter') {
      handleSubmit(event.target.value);
    }
  };
  const handleSearchButtonClick = value => {
    // Only handle clear button clicks (empty value)
    // Regular searches should only happen on Enter key
    if (meetingsPageSearch && !value) {
      updateSearchParam('');
    }
  };
  return <Container>
      <SearchForm onSearch={handleSearchButtonClick} initialValue={initialValue} placeholder={I18n.t('publisher.meetings.search.placeholder')} onKeyPress={handleKeyPress} isFullSized />
    </Container>;
};

require("./search.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./search.js");